import { number, shape, string } from 'prop-types';

export default shape({
  fileName: string,
  bytes: number,
  pages: number,
  guid: string,
});
